import { PayloadAction } from "@reduxjs/toolkit";
import { LayoutState } from "../layout.slice.ts";

export const timeModalReducer = (
  state: LayoutState,
  action: PayloadAction<boolean>,
) => {
  state.isTimeOfferModalOpen = action.payload;
};
